import { createContext, useContext } from 'react';

// create react context for stripe, that holds a clientSecret string
// and a function to update the clientSecret
type StripeContextType = {
  clientSecret: string;
};

export const StripeContext = createContext<StripeContextType>({
  clientSecret: '',
});

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (context === undefined) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};
